module.exports = __webpack_public_path__ + "img/red.e11ba6e0.jpg";